import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateSuspendedSubscriptionSettingParams {
  user: string;
  enabled: boolean;
}

export class UpdateSuspendedSubscriptionSettingRequest extends Request<IUpdateSuspendedSubscriptionSettingParams, IResult> {
  constructor(params: IUpdateSuspendedSubscriptionSettingParams) {
    super('updateSuspendedSubscriptionNotificationSetting', params);
  }
}
